import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_CONTROL_DE_REBAJAS } from '../../../../config/tables'

export default function ControlDeRebajasView () {
  return <MuiTable id={TABLA_CONTROL_DE_REBAJAS} />
}
